import { Component, OnInit } from '@angular/core';
import { DisplayedColumnInf } from '../../../interfaces/common/table/displayed-column-inf';
import { UserPrivilegeService } from '../../../services/common/user-privilege/user-privilege.service';
import {ShortCallsProfilesApiService} from '../../../services/api/settings/routing/short-calls-profiles/short-calls-profiles-api.service';
import { LoaderService } from '../../../services/common/loader-service/loader.service';
import { PageEvent } from '@angular/material/paginator';
import { ServerPageRequest } from '../../../classes/common/table/server-page-request';
import { AcDialogService } from 'ac-infra';
import { ShortCallsProfilesDialogComponent } from './short-calls-profiles-dialog/short-calls-profiles-dialog.component';
import { SnackBarService } from '../../../services/common/snack-bar/snack-bar.service';
import * as _ from 'lodash';
import { ConfirmationDialogComponent } from '../../../dialogs/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';

export class YesNoTransformer {
  transform(value: any, row?: any): string {
    return value ? 'Yes' : 'No';
  }
}

@Component({
  selector: 'short-calls-profiles',
  templateUrl: './short-calls-profiles.component.html',
  styleUrls: ['./short-calls-profiles.component.scss']
})
export class ShortCallsProfilesComponent implements OnInit {

  displayedColumns: Array<DisplayedColumnInf> = [
    { name: 'name', display: 'Name', selected: true, width: 150 },
    { name: 'durationInSec', display: 'Short Call Duration (in sec)', selected: true, width: 120 },
    { name: 'totalCalls', display: 'Min Calls per Day', selected: true, width: 120 },
    { name: 'percentage', display: 'Short Calls %', selected: true, width: 120 },
    { name: 'dropOutgoingCalls', display: 'Drop Call', selected: true, width: 120, transformer: YesNoTransformer },
    { name: 'lockedForOutgoingCalls', display: 'Lock Pcon', selected: true, width: 120, transformer: YesNoTransformer }

  ];

  data = { elements: [], totalElements: 0 };
  isUnauthorized: any;
  selection: any;

  serverPageRequest: ServerPageRequest = new ServerPageRequest({
    pageIndex: 0,
    pageSize: 25,
    length: 0
  });

  constructor(
    private userPrivilege: UserPrivilegeService,
    private shortCallsProfilesApiService: ShortCallsProfilesApiService,
    private loaderService: LoaderService,
    private acDialogService: AcDialogService,
    private snackBarService: SnackBarService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.isUnauthorized = !this.userPrivilege.isAuthorized();
    this.refresh();
  }

  onSelection(selection: any): void {
    this.selection = selection;
  }


  addShortCallsProfile(): void {
    const dialogData = {
      name: '',
      durationInSec: null,
      totalCalls: null,
      percentage: null,
      blockCalls: false
    };

    this.acDialogService.open(ShortCallsProfilesDialogComponent, {
      dialogData,
      title: 'Add Short Calls Profile',
      onSubmit: () => {
        this.shortCallsProfilesApiService.addShortCallsProfile(dialogData).subscribe(() => {
          this.refresh();
          this.snackBarService.display(`"${dialogData.name}" successfully added`);
        });
      }
    });
  }


  refresh(): void {
    this.shortCallsProfilesApiService.getShortCallsProfiles({ ...this.serverPageRequest }).subscribe(data => {
      this.data = data;
    });
  }

  deleteShortCallsProfile(): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: `Are you sure you want to delete the Short Calls Profile: "${this.selection.name}"?`
      }
    });

    dialogRef.componentInstance.onApply.subscribe(() => {
      this.shortCallsProfilesApiService.deleteShortCallsProfile(this.selection.id).subscribe(() => {
        dialogRef.close();
        this.refresh();
        this.snackBarService.display(`${this.selection.name} successfully deleted`);
      }, () => {
      });
    });
  }


  editShortCallsProfile(): void {
    const dialogData = _.cloneDeep(this.selection);
    this.acDialogService.open(ShortCallsProfilesDialogComponent, {
      dialogData,
      title: 'Edit Short Calls Profile',
      onSubmit: () => {
        this.shortCallsProfilesApiService.editShortCallsProfile(dialogData, dialogData.id).subscribe(() => {
          this.refresh();
          this.snackBarService.display(`"${dialogData.name}" successfully updated`);
        });
      }
    });
  }


  pageChanged(pageInfo: PageEvent): void {
    this.serverPageRequest = new ServerPageRequest(pageInfo);
    this.refresh();
  }

}
